import { Lang, QuestionType } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Can Answer That ?',
    nav: {
      one_page: 'Page #{{ pageNo }}, Question #{{ current }}',
      multiple_pages:
        'Page #{{ pageNo }} ({{ first }} - {{ last }}), Question #{{ current }}',
    },
    contextMenu: {
      items: {
        copyLink: 'Copy question link',
        openInNewTab: 'Open question in a new tab',
        report: 'Report question',
        delete: 'Delete question',
      },
      msgs: {
        linkCopied: 'Link copied to clipboard',
        open: 'Open',
      },
    },
    buttons: {
      follow: 'Follow',
      unfollow: 'Followed',
    },
    info: {
      creationTimePassed: 'Created {{ timePassed }}',
      submissionTimePassed: 'Answered {{ timePassed }}',
      creationDateTime: '({{ dateTime }})',
      submittedTimes_one: 'Answered by {{ count }} user',
      submittedTimes: 'Answered by {{ count }} users',
    },
    content: {
      total: 'Total',
      average: 'Average',
      correctAnswers: 'Correct answers',
      correctAnswers_one: 'Correct answer',
      yourAnswers: 'Your answers',
      yourAnswers_one: 'Your answer',
      correct: 'Correct',
      wrong: 'Wrong',
    },
    type: {
      [QuestionType.SingleChoice]: 'Single choice',
      [QuestionType.MultiChoice]: 'Multiple choice',
    },
  },
}
